/**
 * JS color palette equivilent of reactifi/src/styles/scss/variables/_colors.scss
 * This was needed for passing themes and custom styles to library components.
 * Additional note. The import of design-system completely fails. Defining colors here to bypass for now.
 */
const ColorsBlack = '#000000';
const ColorsWhite = '#ffffff';
const ColorsTeal200 = '#c4f2f1';
const ColorsTeal600 = '#0d7978';
const foundryGreen = '#6e9200';
const foundryRed = '#d60000';
const foundryTeal = '#009688';
const foundryYellow = '#ffa609';
const paletteBlackSqueeze = '#ebf7f7';
const paletteBlueStone = '#00605f';
const paletteBoulderVar = '#767676';
const paletteDowny = '#5fc7cc';
const paletteGrenadier = '#cf2600';
const paletteMercury = '#e6e6e6';
const palettePunch = '#d83f1d';
const paletteScienceBlue = '#0168b7';

const COLORS = {
  ColorsBlack,
  ColorsTeal200,
  ColorsTeal600,
  foundryAccent: paletteDowny,
  foundryBlack: ColorsBlack,
  foundryBlue: paletteScienceBlue,
  foundryBluePrimary: '#1976d2',
  foundryBlueSecondary: '#13b2da',
  foundryBodyBackgroundColor: ColorsWhite,
  foundryGray01: '#f9f9f9',
  foundryGray05: '#f2f2f2',
  foundryGray10: paletteMercury,
  foundryGray20: '#cccccc',
  foundryGray30: '#b3b3b3',
  foundryGray40: '#999999',
  foundryGray50: '#808080',
  foundryGray55: paletteBoulderVar,
  foundryGray60: '#666666',
  foundryGray70: '#4d4d4d',
  foundryGray80: '#333333',
  foundryGray90: '#191919',
  foundryGreen,
  foundryHeaderBackgroundColor: ColorsWhite,
  foundryPrimaryHue: palettePunch,
  foundryPrimaryShade: paletteGrenadier,
  foundryRed,
  foundrySecondaryHue: ColorsTeal600,
  foundrySecondaryShadeDark: paletteBlueStone,
  foundrySecondaryShadeLight: '#abc2c2',
  foundrySecondaryShadeLighter: '#d9e6e6',
  foundrySecondaryShadeLightest: '#e7eeee',
  foundrySecondaryTintLight: paletteBlackSqueeze,
  foundrySidebarBackground: '#1c1e1e',
  foundrySidebarExpandedBackground: '#404546',
  foundrySidebarHoverBackground: '#4f5859',
  foundryTeal,
  foundryTeal100: '#dff7f6',
  foundryTealLink: ColorsTeal600,
  foundryTealLinkHover: '#00605f',
  foundryWhite: ColorsWhite,
  foundryYellow,
  paletteAlabaster: '#f7f7f7',
  paletteBlackSqueeze,
  paletteBlueStone,
  paletteBoulder: '#777777',
  paletteBoulderVar,
  paletteDowny,
  paletteDustyGray: '#999',
  paletteGrenadier,
  paletteMercury,
  palettePunch,
  paletteScienceBlue,
  paletteWhite: ColorsWhite,
  paletteWildSand: '#f4f4f4',
  superDuperLight: '#f6f6f6',
};

export default COLORS;
